import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import moment from 'moment'
import currencyFormatter from 'currency-formatter'
import { EVENT_CREATED_BY_VEHICLE } from '../query/event'
import CircularProgress from '@material-ui/core/CircularProgress'
moment.locale('fr')

class ConsumedFuelContentComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      events: props.events,
      firstMetricOfDay: props.firstMetricOfDay
    }
  }

  UNSAFE_componentWillMount () {
    const self = this
    let currentVolume = self.props.currentVolume
    let firstMetricOfDay = self.state.firstMetricOfDay
    let events = self.state.events
    self.setConsumedFuel(currentVolume, firstMetricOfDay, events)
  }

  componentDidMount () {
    const self = this
    let vehicleNumber = self.props.vehicleNumber
    var d = new Date()
    let currentVolume = self.props.currentVolume
    let firstMetricOfDay = self.state.firstMetricOfDay
    this.props.subscribeToMore({
      document: EVENT_CREATED_BY_VEHICLE,
      variables: { occurred_at: d, jsonFilter: { 'trb_imm': vehicleNumber } },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData.data || subscriptionData.data.events.length === 0) {
          return prev
        }
        const currentEventCreated = subscriptionData.data.events
        let myEvents = [
          ...prev.events,
          ...currentEventCreated
        ]
        var consumedFuel = self.getConsumedFuel(currentVolume, firstMetricOfDay, myEvents)
        this.setState({
          events: myEvents,
          consumedFuel: consumedFuel >= 0 ? consumedFuel : self.state.consumedFuel
        })
        return {
          events: myEvents
        }
      }
    })
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    const self = this
    let firstMetricOfDay = self.state.firstMetricOfDay
    let events = self.state.events
    if (this.props.currentVolume !== nextProps.currentVolume) {
      self.setConsumedFuel(nextProps.currentVolume, firstMetricOfDay, events)
    }
  }

  setConsumedFuel (currentVolume, firstMetricOfDay, events) {
    const self = this
    var consumedFuel = self.getConsumedFuel(currentVolume, firstMetricOfDay, events)
    self.setState({
      consumedFuel: consumedFuel >= 0 ? consumedFuel : self.state.consumedFuel
    })
  }

  getConsumedFuel (currentVolume, firstMetricOfDay, events) {
    const self = this
    var consumedFuel
    if (events.length > 0) {
      consumedFuel = self.getConsumedFuelWithEvent(currentVolume, firstMetricOfDay, events)
    } else {
      consumedFuel = firstMetricOfDay.length === 0 ? 0 : (firstMetricOfDay[0].value - currentVolume)
    }
    return consumedFuel
  }

  getConsumedFuelWithEvent (currentVolume, firstMetricOfDay, events) {
    var consumedFuel
    var firstValue = firstMetricOfDay[0].value
    if (events.length === 1) {
      if (events[0].metadata.current_volume === firstValue) {
        consumedFuel = firstValue - currentVolume
      } else {
        consumedFuel = (firstValue - events[0].metadata.metric_at.volume) + (events[0].metadata.metric_end.volume - currentVolume)
      }
    } else {
      var s = 0
      for (var i = 0; i < events.length - 2; i++) {
        s = s + (events[i].metadata.metric_end.volume - events[i + 1].metadata.metric_at.volume)
      }
      if (events[0].metadata.current_volume === firstValue) {
        consumedFuel = s + (events[events.length - 1].metadata.metric_end.volume - currentVolume)
      } else {
        consumedFuel = s + (firstValue - events[0].metadata.metric_at.volume) + (events[events.length - 1].metadata.metric_end.volume - currentVolume)
      }
    }
    return consumedFuel
  }

  render () {
    let consumedFuel = this.state.consumedFuel
    if (!consumedFuel && consumedFuel !== 0) {
      return <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
    }
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='CARBURANT CONSOMMÉ'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.content}>
            <span style={styles.number}>{currencyFormatter.format(consumedFuel, {
              symbol: '',
              decimal: ',',
              thousand: ' ',
              precision: 1,
              format: '%v %s'
            })}<br /> <span style={styles.unit}>{consumedFuel > 1 ? 'Litres' : 'Litre'}</span></span>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  content: {
    textAlign: 'center',
    width: '100%',
    height: '80px',
    marginTop: '98px'
  },
  number: {
    fontSize: '42px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  },
  unit: {
    fontSize: '14px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  }
}

export default ConsumedFuelContentComponent
